export const environment = {
  production: true,
  base: undefined,
  websocketBase: undefined,
  // TODO: remove AJAXREQUEST when TAI agent is dropped
  configEndpoint: '/waw/brk/wb/services/rest/v1/configuration/${applicationId}?AJAXREQUEST=1',
  allowedPostMessageDomain: 'td.com',
  animationsDisabled: false
};
